var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * Global proctoring capture-resolution config (read side, used by the live
 * interview paths). The backend exposes a single admin-tunable width; the
 * frontend downscales each proctoring frame to it before sending. The historical
 * value was a hardcoded 320 — that stays the default here so ANY failure
 * (endpoint missing, network error, bad payload) keeps behaviour byte-identical.
 */
export const DEFAULT_PROCTORING_CAPTURE_WIDTH = 320;
const MIN_WIDTH = 160;
const MAX_WIDTH = 1920;
export function fetchProctoringCaptureWidth(apiBaseUrl) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            // VA-27778: `apiBaseUrl` already ends in `/api`, and this route is registered
            // one level up from the `api/api/...` endpoints — so the extra segment here
            // made every call a 404. It failed quietly (the catch below returns the
            // default), so the admin-tuned capture width was silently ignored and every
            // interview ran at the hardcoded 320px fallback instead.
            const res = yield fetch(`${apiBaseUrl}/proctoring/config/`, { method: 'GET' });
            if (!res.ok)
                return DEFAULT_PROCTORING_CAPTURE_WIDTH;
            const data = yield res.json();
            const w = Number(data === null || data === void 0 ? void 0 : data.capture_width);
            if (!Number.isFinite(w) || w < MIN_WIDTH || w > MAX_WIDTH) {
                return DEFAULT_PROCTORING_CAPTURE_WIDTH;
            }
            return Math.round(w);
        }
        catch (_a) {
            return DEFAULT_PROCTORING_CAPTURE_WIDTH;
        }
    });
}
